import * as React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { registerArenaServiceWorker } from './lib/arena-web-app'
import { isArenaNotificationSetupHost } from './lib/arena'
import { browserNotificationRuntime } from './lib/browser-notification-runtime'
import { I18nProvider } from './lib/i18n'

void registerArenaServiceWorker(browserNotificationRuntime, {
  localArena: isArenaNotificationSetupHost(),
}).catch((error) => {
  console.warn(
    '[web-app] Service Worker registration failed',
    error instanceof Error ? error.message : String(error),
  )
})

ReactDOM.createRoot(document.querySelector('#root')!).render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>,
)
